var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"QuickSearchLayout__container"},[_c('div',{staticClass:"condition-panel"},[_vm._t("condition")],2),_c('div',{staticClass:"list-panel"},[_vm._t("list")],2),_c('div',{staticClass:"pagination-panel"},[_vm._t("pagination")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }